import { useState, useCallback } from 'react';

export function useCallbackRef<T>() {
  const [ref, setRef] = useState<T | null>(null);
  const fn = useCallback((node: T | null) => {
    setRef(node);
  }, []);

  return [ref, fn] as const;
}
